module.exports = __webpack_public_path__ + "static/media/game-credit-giphy.47f3dff5.png";